import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ModalLink from './ModalLink'
import AddToModal from './AddToModal'
import { addResourceStrings, translateResourceString } from '../util/translationUtility'

// Retrieves select if it exists
function getVariationsSelect() {
    return document
        ? document.getElementById("variations-select")
        : null;
}

const AddToWishlistApp = ({
    Name,
    SKU,
    ImageUrl,
    Wishlists,
    AddItemEndpoint,
    AddListEndpoint,
    Variations,
    UserIsAuthorized,
    LoginLink,
    LocalizationItems
}) => {
    addResourceStrings(LocalizationItems);

    const [Lists, updateLists] = useState(Wishlists);
    const [ModalIsOpen, toggleModal] = useState(false);
    const [linkClass, setLinkClass] = useState('fa fa-bookmark');
    const [srText, setSrText] = useState('');
    const [linkText, setLinkText] = useState(translateResourceString("/Product/AddToListButton"));
    const [sku, setSku] = useState(SKU);

    function handleVariationSelect() {
        setSku(getVariationsSelect().value);
        setLinkText(translateResourceString("/Wishlists/AddToModal/AddToListButton"));
    }

    useEffect(() => {
        // Bind the event listener
        const variationsSelect = getVariationsSelect();

        if (variationsSelect) {
            variationsSelect.addEventListener("change", handleVariationSelect);
        }

        return () => {
            // Unbind the event listener on clean up
            if (variationsSelect) {
                variationsSelect.removeEventListener("change", handleVariationSelect);
            }
        };
    });

    const name = Variations ? Variations[sku].DisplayName : Name;

    return (
        <Fragment>
            <ModalLink
                ClassName={linkClass}
                LinkText={linkText}
                SrText={srText}
                ToggleModal={toggleModal}
             />

            <AddToModal
                Lists={Lists}
                UpdateLists={updateLists}
                Name={name}
                ImageUrl={ImageUrl}
                SKU={sku}
                ModalIsOpen={ModalIsOpen}
                ToggleModal={toggleModal}
                AddItemEndpoint={AddItemEndpoint}
                CreateListEndpoint={AddListEndpoint}
                SetLinkClass={setLinkClass}
                SetSrText={setSrText}
                SetLinkText={setLinkText}
                UserIsAuthorized={UserIsAuthorized}
                LoginLink={LoginLink} />
        </Fragment>
    );
};

AddToWishlistApp.propType = {
    Wishlists: PropTypes.arrayOf(
        PropTypes.shape({
            Name: PropTypes.string
        })
    ).isRequired,
    AddItemEndpoint: PropTypes.string.isRequired,
    AddListEndpoint: PropTypes.string.isRequired,
    UserIsAuthorized: PropTypes.bool.isRequired,
    LoginLink: PropTypes.string.isRequired
};

export default AddToWishlistApp;